import React, { useEffect, useState } from 'react';
import { message, Col, Row, Modal, Space } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { orderPurchaseCustomerQualityInfo } from '../../api';
const Detail = (props) => {
  const { quality_id } = props?.match?.params;
  const [infoData, setInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentOptions, setCurrentOptions] = useState({});
  useEffect(() => {
    setLoading(false);
    async function portQualityReportInfo() {
      const { data: { code, msg, data } } = await orderPurchaseCustomerQualityInfo(({ id: quality_id }));
      if (+code === 0) {
        setInfo(data);
      } else {
        message.error(msg);
      }
      setLoading(true);
    }
    portQualityReportInfo();
  }, [quality_id]);
  const showModal = (options = {}) => {
    setCurrentOptions(options);
    setModalVisible(true);
  };
  const handleOk = () => {
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };
  return (<div className='quality-report-container'>
    <Space className='mb-20' split={<RightOutlined />}>
      <Link to={{ pathname: '/basic/user/order' }}>我的采购单</Link>
      <span>订单号：{infoData.order_no}</span>
      <span>查看质检记录</span>
    </Space>
    {
      loading ? <>
        <div className='port-quality-report-base'>
          <div >
            <div className='port-quality-report-title'>基本信息</div>
          </div>
          <Row style={{ marginTop: 20 }}>
            <Col span={4}>批次号：{infoData?.bit_no}</Col>
            <Col span={4}>柜号: {infoData?.container_no}</Col>
            <Col span={12}>质检时间: {infoData?.customer_quality_time}</Col>
          </Row>
          <Row>
            <Col span={12}>反馈来源:{infoData?.feedback_source}</Col>
          </Row>
        </div>
        <div className='port-quality-report-base'>
          <div >
            <div className='port-quality-report-title'>详细记录</div>
          </div>
          {
            (infoData?.products || []).map((item, index) => {
              
              return <div key={index} style={{ marginTop: 20 }}>
                <h4 style={{fontWeight:'bold'}}>{item?.product?.sku_name}</h4>
                {
                  item?.crack_open?.checked ? <div style={{marginLeft:10}}>
                    <Row>
                      <Col span={4}>{item?.crack_open?.label}</Col><Col span={4}>{item?.crack_open?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.crack_open?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.crack_open?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.dead_package?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.dead_package?.label}</Col><Col span={4}>{item?.dead_package?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.dead_package?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.dead_package?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.insect_infestation?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.insect_infestation?.label}</Col><Col span={4}>{item?.insect_infestation?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.insect_infestation?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.insect_infestation?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.nuclear_burning?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.nuclear_burning?.label}</Col><Col span={4}>{item?.nuclear_burning?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.nuclear_burning?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.nuclear_burning?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.partial?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.partial?.label}</Col><Col span={4}>{item?.partial?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.partial?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.partial?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.pulp_water?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.pulp_water?.label}</Col><Col span={4}>{item?.pulp_water?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.pulp_water?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.pulp_water?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.raw_bread?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.raw_bread?.label}</Col><Col span={4}>{item?.raw_bread?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.raw_bread?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.raw_bread?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.rotten_thorn?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.rotten_thorn?.label}</Col><Col span={4}>{item?.rotten_thorn?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.rotten_thorn?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.rotten_thorn?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.tiger_grouper?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.tiger_grouper?.label}</Col><Col span={4}>{item?.tiger_grouper?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.tiger_grouper?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.tiger_grouper?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.weak_flesh?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.weak_flesh?.label}</Col><Col span={4}>{item?.weak_flesh?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.weak_flesh?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.weak_flesh?.remark}</Col>
                    </Row>
                  </div> : ''
                }
                {
                  item?.other?.checked ? <div style={{marginLeft:10}}>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={4}>{item?.other?.label}</Col><Col span={4}>{item?.other?.weight} kg</Col>
                    </Row>
                    <div className='port-quality-report-item-imgs'>
                      {(item?.other?.pics || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item?.url} alt='' />)}
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>备注：{item?.other?.remark}</Col>
                    </Row>
                  </div> : ''
                }
              </div>;
            })
          }
        </div>
      </> : null
    }
    {
      modalVisible && <Modal open={true} onOk={handleOk} onCancel={handleCancel} footer={null} centered>
        <div className='port-quality-report-modal-content'>
          {(currentOptions?.type === 'image') && <img className='port-quality-report-modal-camera' src={currentOptions?.item?.url} alt='' />}
          {(currentOptions?.type === 'video') && <video className='port-quality-report-modal-camera' controls controlsList="nofullscreen nodownload noremoteplayback" disablePictureInPicture><source src={currentOptions?.item} /></video>}
        </div>
      </Modal>
    }
  </div>);
};
export default Detail;
